module.exports = __webpack_public_path__ + "media/2.40350dc8.mp3";